import { GifsResult } from '@giphy/js-fetch-api'
import { ReactNode } from 'react'
import { PortalTooltipContext } from 'ui'
import { MediaInfo } from '../../../types'
import UgeArtboardContextManager from './artboard'
import UgeCropContextManager from './crop'
import UgeEditorContextManager from './editor'
import UgeLayersContextManager from './layers'

type Props = {
    apiKey: string
    children?: ReactNode
    source: File | string
    sourceInfo: MediaInfo
    fetchFavorites?: (offset: number) => Promise<GifsResult>
    getTime: () => number
    goToTime: (time: number) => void
}

const UgeContextManager = ({ apiKey, children, getTime, goToTime, source, sourceInfo, fetchFavorites }: Props) => {
    return (
        <PortalTooltipContext>
            <UgeArtboardContextManager getTime={getTime} goToTime={goToTime} source={source} sourceInfo={sourceInfo}>
                <UgeEditorContextManager apiKey={apiKey} fetchFavorites={fetchFavorites}>
                    <UgeLayersContextManager>
                        <UgeCropContextManager>{children}</UgeCropContextManager>
                    </UgeLayersContextManager>
                </UgeEditorContextManager>
            </UgeArtboardContextManager>
        </PortalTooltipContext>
    )
}

export default UgeContextManager
